var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMarkCrFr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 3.16683C5.05449 3.16683 2.66668 5.55464 2.66668 8.50016C2.66668 11.4457 5.05449 13.8335 8.00001 13.8335C10.9455 13.8335 13.3333 11.4457 13.3333 8.50016C13.3333 5.55464 10.9455 3.16683 8.00001 3.16683ZM1.33334 8.50016C1.33334 4.81826 4.31811 1.8335 8.00001 1.8335C11.6819 1.8335 14.6667 4.81826 14.6667 8.50016C14.6667 12.1821 11.6819 15.1668 8.00001 15.1668C4.31811 15.1668 1.33334 12.1821 1.33334 8.50016Z",
    fill: "#AC320C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66668 5.83317C8.66668 5.46498 8.3682 5.1665 8.00001 5.1665C7.63182 5.1665 7.33334 5.46498 7.33334 5.83317V8.49984C7.33334 8.86803 7.63182 9.1665 8.00001 9.1665C8.3682 9.1665 8.66668 8.86803 8.66668 8.49984V5.83317Z",
    fill: "#AC320C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 10.4998C7.63182 10.4998 7.33334 10.7983 7.33334 11.1665C7.33334 11.5347 7.63182 11.8332 8.00001 11.8332C8.3682 11.8332 8.66668 11.5347 8.66668 11.1665C8.66668 10.7983 8.3682 10.4998 8.00001 10.4998Z",
    fill: "#AC320C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkCrFr);
export default __webpack_public_path__ + "static/media/exclamation_mark_cr_fr.f7b5d162c4544276d6eac309f8bff898.svg";
export { ForwardRef as ReactComponent };